<template>
    <b-modal
        v-model="modalShow"
        size="md"
        title="Googleカレンダーと連携中"
        hide-footer>
        <template>
            <div class="mb-2">Googleカレンダー連携を解除すると、今後新たに入ってくる{{ $locale.consultation_host }}予約についてはGoogleカレンダーへ反映されなくなります。なお、これまでに連携された{{ $locale.consultation_host }}予約はGoogleカレンダー上に残ります。</div>
            <div class="mb-4 text-muted small">（※&nbsp;連携解除後に再度Googleカレンダーと連携することは可能です）</div>
            <div class="mb-2 d-flex justify-content-center" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <b-button class="btn btn-yokumiru-red mx-2" @click="onUnlink">
                    Googleカレンダー連携を解除する
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'

    export default {
        props: {},
        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                inProgress: false,
            };
        },

        created: function() {
            bus.$on('open-modal-doctor-google-account-link-cancel', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-doctor-google-account-link-cancel')
        },

        methods: {
            open: function () {
                this.modalShow = true
            },

            close: function () {
                this.modalShow = false
            },

            onUnlink: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const endpoint = `${constants.doctor.google_calendars.endpoint.base}/unlink`

                await axios.put(endpoint)
                    .then(({data}) => {
                        bus.$emit('alert-success', 'Googleカレンダー連携を解除しました')
                        bus.$emit('change-link-calendar')
                        this.close()
                    })
                    .catch(() => {
                        bus.$emit('alert-danger', 'システムエラーが発生しました')
                    })

                this.inProgress = false
            }
        },
    }
</script>
